import {
  Button,
  Dialog,
  FormInputDate,
  FormInputText,
  P,
} from '@fashionnovateam/nova-ui-toolkit';
import { useState } from 'react';
import moment from 'moment/moment';
import { useMarkCounterSampleAsShipped } from '../hooks/queries';
import { useCounterContext } from '../hooks/useCounter';
import toast from '../../Toast/Toast';

const isValidUrl = (string: string): boolean => {
  try {
    return Boolean(new URL(string));
  } catch (_) {
    return false;
  }
};

function CounterShippedDialog({
  handleClose,
  open,
}: {
  handleClose: () => void;
  open: boolean;
}) {
  const { selectedCounter, userId } = useCounterContext();
  const [selectedDate, setSelectedDate] = useState<string>('');
  const [trackingUrl, setTrackingUrl] = useState<string>('');
  const [urlError, setUrlError] = useState<string>('');
  const markAsShipped = useMarkCounterSampleAsShipped();

  const handleMarkAsShipped = async () => {
    if (!userId || !selectedCounter) {
      return;
    }
    try {
      await markAsShipped.mutateAsync({
        userId,
        counterId: selectedCounter.counter_id,
        data: {
          counter_sample_shipped_at: selectedDate,
          counter_sample_tracking: trackingUrl,
        },
      });
      setSelectedDate('');
      setTrackingUrl('');
      toast(
        { title: 'Sample successfully marked as shipped' },
        { type: 'success' },
      );
      handleClose();
    } catch (error) {
      console.error('Failed to mark sample as shipped:', error);
      toast({ title: 'Failed to mark sample as shipped' }, { type: 'error' });
    }
  };

  const handleUrlChange = (url: string) => {
    setTrackingUrl(url);
    if (url && !isValidUrl(url)) {
      setUrlError('Please enter a valid URL');
    } else {
      setUrlError('');
    }
  };

  return (
    <Dialog isOpen={open} onClose={handleClose}>
      <Dialog.Header />
      <Dialog.Content className="w-full">
        <div className="flex flex-col gap-6 w-full">
          <div className="flex-col mb-6">
            <Dialog.Title>Mark vendor sample as shipped</Dialog.Title>
            <P size="xsm" color="disabled">
              Please provide the details of your shipment.
            </P>
          </div>
          <FormInputDate
            notAfter={moment().format('YYYY-MM-DD')}
            className="w-full"
            containerClassName="w-full"
            label="Date Vendor Sample Shipped"
            required
            value={selectedDate}
            onChangeValue={setSelectedDate}
          />
          <FormInputText
            label="Tracking URL"
            value={trackingUrl}
            onChangeValue={handleUrlChange}
            error={urlError}
          />
        </div>
      </Dialog.Content>
      <Dialog.Footer>
        <div className="flex gap-2 justify-end">
          <Button color="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleMarkAsShipped}
            loading={markAsShipped.isLoading}
            disabled={!selectedDate || !!urlError}
          >
            Mark as Shipped
          </Button>
        </div>
      </Dialog.Footer>
    </Dialog>
  );
}

export default CounterShippedDialog;
